import Vue from "vue";

Vue.filter("abc", function(array, string)
{
    array.sort(function(objA, objB)
    {
        const nameA = objA.details[0].name.type.toLowerCase();

        const nameB = objB.details[0].name.type.toLowerCase();

        if (nameA < nameB)
        {
            return -1;
        }
        if (nameA > nameB)
        {
            return 1;
        }
        return 0;
    });

    return array;
});
